module.exports = __webpack_public_path__ + "static/img/icon_dingtou.02059c4e.png";